import React from 'react';

const whatsappDemoUrl = 'https://api.whatsapp.com/send?phone=212645400000';

const WhatsAppBankOfAfricaInfo = () => {
  return (
    <div className="demo-info-container" style={{ maxWidth: 800, margin: '40px auto' }}>
      <h1 style={{ color: '#111', marginBottom: 16, fontSize: 32 }}>WhatsApp Multilingual Agent</h1>
      <img src="/assets/img/bank-of-africa.png" alt="Bank of Africa Logo" style={{ width: 280, margin: '0 0 30px 0', display: 'block' }} />
      <p style={{ fontSize: 20, marginBottom: 40, lineHeight: 1.8 }}>
        Here is a multilingual WhatsApp agent developed for <b>Bank of Africa</b>.<br/>
        This demo allows you to interact with the agent in multiple languages via WhatsApp.
      </p>
      <a href={whatsappDemoUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <button className="whatsapp-btn" style={{ fontSize: 18, padding: '14px 28px' }}>
  <img src="/assets/img/whatsapp.png" alt="WhatsApp" style={{ width: 32, height: 32, marginRight: 12 }} />
  Open WhatsApp Demo
</button>
      </a>
    </div>
  );
};

export default WhatsAppBankOfAfricaInfo;
